var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 3.1665H11.0834C6.7111 3.1665 3.16669 6.71092 3.16669 11.0832V26.9165C3.16669 31.2888 6.7111 34.8332 11.0834 34.8332H26.9167C31.2889 34.8332 34.8334 31.2888 34.8334 26.9165V11.0832C34.8334 6.71092 31.2889 3.1665 26.9167 3.1665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 18.0025C25.5287 19.3202 25.3037 20.666 24.6901 21.8484C24.0766 23.0309 23.1058 23.9897 21.9159 24.5886C20.726 25.1876 19.3775 25.396 18.0623 25.1844C16.7471 24.9727 15.5321 24.3518 14.5902 23.4098C13.6482 22.4679 13.0272 21.2529 12.8156 19.9377C12.604 18.6224 12.8124 17.274 13.4114 16.0841C14.0103 14.8942 14.9691 13.9234 16.1516 13.3099C17.334 12.6963 18.6798 12.4713 19.9975 12.6667C21.3416 12.866 22.586 13.4923 23.5469 14.4531C24.5077 15.414 25.134 16.6584 25.3333 18.0025Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 10.2915H27.7251",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8ea22e300149a05bd7c1131f88be47e3.svg";
export { ForwardRef as ReactComponent };